<template functional>
  <div class="v2_info-popup__body">
    <ul class="list-style-disc pl-3">
      <li>
        Click "Begin Study" to anonymously contribute your practice information to our specialty crowdsourced
        database.
      </li>
      <li>
        Review the status of crowdsourced specialty studies.
      </li>
      <li>
        Open and complete study Modules to access additional specialty data.
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'StudyInfoPopupContent',
};
</script>

<style scoped lang="scss">
.v2_info-popup__body {
  padding: 0 20px;
  ul {
    list-style-type: none;
    padding: 0;
  }
}
</style>
